import { mapActions, mapGetters, mapMutations } from "vuex";

import Vue from "vue";
import GSignInButton from "vue-google-signin-button";

Vue.use(GSignInButton);

export default {
    name: "google-widget",
    data() {
        return {
            // client_id is the only required property but you can add several more params, full list down bellow on the Auth api section
            googleSignInParams: {
                client_id: process.env.VUE_APP_GOOGLE_IDENTITY,
            },
        };
    },
    components: {
        GSignInButton,
    },
    computed: {
        ...mapGetters({
            popupRegister: "auth/popupRegister",
            signInLoading: "auth/singInGoogleLoading",
        }),
    },
    methods: {
        ...mapActions({
            auth: `auth/SING_IN_WITH_GOOGLE`,
            link: `profile/LINK_WITH_GOOGLE`,
            fetchUser: `profile/FETCH_USER_DATA`,
            fetchFavouriteList: `favorites/GET_FAVORITES_LIST`,
        }),
        ...mapMutations({
            changePopupRegister: `auth/CHANGE_POPUP_REGISTER`,
        }),
        onSignInSuccess(googleUser) {
            const token = googleUser.getAuthResponse("access_token").access_token;
            if (this.$route.name.includes("info")) {
                this.link({ token: token })
                    .then(() => {
                        this.fetchUser().then(() => {
                            this.$toasted.success(this.$t("successLinkToAccount"));
                            this.fetchFavouriteList();
                        });
                    })
                    .catch(error => {
                        if (error.response.status === 418) {
                            this.$toasted.error(error.response.data.data.error.message);
                        }
                    });
            } else {
                this.auth({ token: token })
                    .then(() => {
                        this.changePopupRegister({ show: false });
                        this.fetchUser().then(() => {
                            this.$router.push({ name: "profile" }).catch(() => {
                                console.log();
                            });
                            this.fetchFavouriteList();
                        });
                        this.$toasted.success(this.$t("successAuth"));
                    })
                    .catch(error => {
                        this.changePopupRegister({ show: false });
                        if (error.response.status === 418) {
                            this.$toasted.error(error.response.data.data.error.message);
                        }
                    });
            }
        },
        onSignInError(error) {
            console.log(error);
        },
    },
};
